import { render } from "./IconHistory.vue?vue&type=template&id=629b55ca"
import script from "./IconHistory.vue?vue&type=script&lang=js"
export * from "./IconHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__